import Component from '../core/Component';
import $ from 'jquery';
import enquire from 'enquire.js';
import { queries } from '../core/config';
import loadTouchEvents from 'jquery-touch-events';
loadTouchEvents($);

export default class Carousel extends Component {
    constructor($element) {
        super($element);
        this.carouselItems = $element.find('[data-carousel-item]');
        this.carouselContent = $element.find('[data-carousel-content]');
        this.carouselControlItems = $element.find('[data-carousel-control-item]');
        this.carouselArrows = $element.find('[data-carousel-arrow]');
        this.loop = null;
        this.timeout = null;
        this.index = 0;
        this.time = 5000;
        this.loopSetting = this.$element.data('loop')

        // fix this
        // this.loopSetting = false

        this.max = this.carouselItems.length / this.carouselContent.length;

    }

    prepare() {

        var self = this;
        this.carouselItems.eq(0).addClass('is-active');
        this.carouselControlItems.eq(0).addClass('is-active');

        this.carouselControlItems.each((index, item) => {
            var $link = $(item).find('a')
            if (window.location.hash == $link.attr('href')) {
                this.makeActive($(item).index())
            }
        })

        this.createLoop();
        
        this.carouselControlItems.on('click', function (event) {
            event.preventDefault()
            var $item = $(this);
            self.index = $item.index();
            self.carouselControlItems.removeClass('fix');
            $item.addClass('fix');
            self.makeActive($item.index());
            //clearInterval(self.loop);
            //clearInterval(self.timeout);
            //self.timeout = setTimeout(function () {
            //    self.createLoop();
            //    $item.removeClass('fix');
            //}, 8000)

            var url = $(this).find('a').attr('href')
            if (url != null) {
                window.history.replaceState({
                    "html": null,
                    "pageTitle": document.querySelector('title').innerHTML
                }, "",  url)
            }
        });
        this.carouselArrows.on('click', function () {
                self.carouselControlItems.removeClass('fix');
                if ($(this).data('carousel-arrow') == 'prev') {
                    self.prev();
                } else if ($(this).data('carousel-arrow') == 'next') {
                    self.next();
                }
                self.createLoop();
            });
        enquire.register(queries.mediumMax, {
            match: () => {
                this.$element.on('swipeleft', event => {
                    self.next();
                    self.createLoop();
                });
                this.$element.on('swiperight', event => {
                    self.prev();
                    self.createLoop();
                });
            }
        });
    }

    createLoop () {
        console.log(this.loopSetting)
        if (this.loopSetting) {
            clearInterval(this.loop);
            this.loop = setInterval(() => {
                this.next();
            }, this.time);
        }
    }

    next() {
        this.index++;

        if (this.index == this.max) {
            this.index = 0;
        }

        this.makeActive(this.index);
    }

    prev() {
        this.index--;

        if (this.index < 0) {
            this.index = this.max-1;
        }

        this.makeActive(this.index);
    }

    eraseActiveClasses () {
        this.carouselItems.removeClass('is-active')
        this.carouselItems.addClass('is-unloading')
        setTimeout(() => {
            this.carouselItems.removeClass('is-unloading')
        }, 800)

        this.carouselControlItems.removeClass('is-active')
    }

    makeActive (index) {
        var i = parseInt(index || this.index)
        this.eraseActiveClasses()

        this.carouselContent.each(function () {
            $(this).find('[data-carousel-item]').eq(i).addClass('is-active')
            // var iframe = $(this).find('[data-carousel-item]').eq(i).find('iframe')
            //     if(iframe.length) {
            //         iframe[0].src += "&autoplay=1";    
            //     }
        })
        this.carouselControlItems.eq(i).addClass('is-active')
    }

}


// WEBPACK FOOTER //
// ./components/Carousel.js